import { useEffect } from 'react';
import { DataGridPro, GridRowSelectionModel } from '@mui/x-data-grid-pro';
import { SubMenu } from './SubMenu';
import { useTranslation } from 'react-i18next';
import { NoRowsOverlay } from 'shared/ui/table/NoRowsOverlay';
import { useAccrualDatesTable } from 'hooks/accrualDates/useAccrualDatesTable';

const AccrualDatesTable = () => {
    const { t } = useTranslation();
    const { columns, rows, loading, contextMenu, setContextMenu, selectedRow, setSelectedRow, selected, setSelected, cleanSelected, reloading } = useAccrualDatesTable();

    useEffect(() => {
        reloading();
    }, [reloading]);

    return (
        <div
            style={{ width: '100%', height: '100%' }}
            onContextMenu={(event) => {
                event.preventDefault();
                setContextMenu(contextMenu === null ? { mouseX: event.clientX + 2, mouseY: event.clientY - 6 } : null);
            }}
        >
            <DataGridPro
                sx={{ height: 'calc(100vh - 140px)' }}
                columns={columns}
                rows={rows}
                loading={loading}
                rowSelectionModel={selected}
                pagination
                onRowSelectionModelChange={(newRowSelectionModel: GridRowSelectionModel) => {
                    let row = rows.filter((row: any) => newRowSelectionModel.includes(row.id));
                    setSelected(newRowSelectionModel);
                    setSelectedRow(row);
                }}
                checkboxSelection
                localeText={{
                    headerFilterOperatorContains: t('general.table.headerFilters.headerFilterOperatorContains'),
                    headerFilterOperatorEquals: t('general.table.headerFilters.headerFilterOperatorEquals'),
                    headerFilterOperatorStartsWith: t('general.table.headerFilters.headerFilterOperatorStartsWith'),
                    headerFilterOperatorEndsWith: t('general.table.headerFilters.headerFilterOperatorEndsWith'),
                    headerFilterOperatorIsEmpty: t('general.table.headerFilters.headerFilterOperatorIsEmpty'),
                    headerFilterOperatorIsNotEmpty: t('general.table.headerFilters.headerFilterOperatorIsNotEmpty'),
                    footerRowSelected: (count) => (count > 1 ? `${count.toLocaleString()} filas seleccionadas` : `${count.toLocaleString()} fila seleccionada`),

                    footerTotalRows: t('general.table.footerFilters.footerTotalRows'),
                    MuiTablePagination: {
                        labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} of ${count === -1 ? `more than ${to}` : count}`,
                        labelRowsPerPage: t('general.table.footerFilters.labelRowsPerPage'),
                    },
                }}
                showCellVerticalBorder
                showColumnVerticalBorder
                disableColumnMenu
                headerFilters
                slotProps={{
                    toolbar: {
                        showQuickFilter: true,
                    },
                }}
                slots={{
                    noRowsOverlay: NoRowsOverlay,
                    noResultsOverlay: NoRowsOverlay,
                }}
            />
            <SubMenu selected={selectedRow} cleanSelected={cleanSelected} rows={rows} contextMenu={contextMenu} setContextMenu={setContextMenu} reloading={reloading} />
        </div>
    );
};

export { AccrualDatesTable };
